import React from "react";
import { useTranslation } from "react-i18next";
import { PageTitle } from "../pageTitle";
import { LegalContentRenderer, useLegalSections } from "./LegalContentRenderer";
import "../../App.css";

export function LegalPage({ namespace }) {
  const { t } = useTranslation(namespace);
  const sections = useLegalSections(namespace);

  return (
    <main className="inner-page inner-page--legal">
      <PageTitle title={t("title")} />
      <div className="container inner-page__body">
        <LegalContentRenderer sections={sections} />
      </div>
    </main>
  );
}
